<template>
  <div class="relative rounded-sm shadow-sm">
    <div
      class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3"
    >
      <span class="text-gray-500 sm:text-sm">€</span>
    </div>
    <input
      ref="inputRef"
      :value="modelValue"
      @input="emit('update:modelValue', $event)"
      :disabled="disabled"
      class="pl-7 block w-full rounded-sm border bg-white border-gray-300 focus:border-gray-500 focus:ring-gray-500 sm:text-sm shadow-sm z-auto"
      :class="{
        'opacity-60 !cursor-not-allowed': disabled,
      }"
      type="text"
      v-bind="$attrs"
      :autofocus="autofocus"
    />
  </div>
</template>

<script setup>
import { useCurrencyInput } from "vue-currency-input";

defineProps({
  modelValue: {
    type: String,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  autofocus: {
    type: Boolean,
    default: false,
  },
});

const { inputRef } = useCurrencyInput({
  currency: "EUR",
  currencyDisplay: "hidden",
});
</script>
